import { render, staticRenderFns } from "./EventCompaniesEditor.vue?vue&type=template&id=10e75143&"
import script from "./EventCompaniesEditor.vue?vue&type=script&lang=js&"
export * from "./EventCompaniesEditor.vue?vue&type=script&lang=js&"
import style0 from "./EventCompaniesEditor.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports